import { FilterType } from '@/components/filters/types';
import { Badge } from '@/components/ui/badge';
import { cn, formatFilterValue } from '@/lib/utils';
import { X } from 'lucide-react';

type Props = {
  activeFilters: FilterType[];
  removeFilter: (filter: FilterType) => () => void;
  className?: string;
};

export const FilterBadge = ({
  filter,
  removeFilter,
  className,
}: {
  filter: FilterType;
  removeFilter: (filter: FilterType) => () => void;
  className?: string;
}) => {
  const getFilterLabel = (filter: FilterType) => {
    let separator =
      filter.type === 'true_false' || filter.type === 'no_value' ? '' : ': ';

    return filter.label !== '' ? filter.label + separator : '';
  };

  return (
    <Badge
      variant='outline'
      className={cn(
        'bg-brand-grey1 h-[34px] gap-2 rounded-sm border-0 px-2 py-3 text-xs',
        className,
      )}
      key={`${filter.name}-${filter.type}-${filter.value}`}
      data-pw={`${filter.name}-filter-badge`}
    >
      <div className='font-medium'>
        <span>{getFilterLabel(filter)}</span>
        {filter.type !== 'no_value' && (
          <span>{formatFilterValue(filter.value)}</span>
        )}
        {filter.suffix && <span>{filter.suffix}</span>}
      </div>
      {(filter.removeable === true || filter.removeable === undefined) && (
        <X
          size={14}
          className='cursor-pointer transition-colors duration-100 hover:text-red-700'
          onClick={removeFilter(filter)}
        />
      )}
    </Badge>
  );
};

export const FilterBadges = ({
  activeFilters = [],
  removeFilter,
  className,
}: Props) => {
  if (activeFilters.length === 0) return null;

  return activeFilters.map((filter) => {
    return (
      <FilterBadge
        key={`${filter.name}-${filter.type}-${filter.value}`}
        filter={filter}
        removeFilter={removeFilter}
        className={className}
      />
    );
  });
};
